import {
  HStack,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spacer,
  Stack,
  Text
} from '@chakra-ui/react';
import { format } from 'date-fns';

import { HorizontalDotMenuIcon, SFTrashIcon } from '@assets/icons';
import { formatTimeDistance } from '@util/helpers';
import SourceLogo from '@components/general/source-logo.component';

/**
 * @param {Object} props
 * @param {Card} props.card
 * @param {(sourceId: string) => Promise<void>)} props.onRemove
 */
const ExplorerSourceCard = ({ card, onRemove, hideMenu = false }) => {
  return (
    <HStack
      border='reskin'
      rounded='xl'
      p={3}
      bgColor='surface.containerLow'
      color='surface.onSurfaceVariant'
    >
      <SourceLogo
        sourceType={card?.source}
        subSource={card?.sub_source}
        source={card?.source_data}
        tags={card?.tags}
        boxSize={5}
        m={1}
        alignSelf='start'
      />
      <Stack gap={1}>
        <Text
          color='surface.onSurface'
          variant='title-md'
          noOfLines={1}
        >
          {card?.source_data?.title}
        </Text>
        <HStack gap={3}>
          <Text
            variant='label-reg-lg'
            noOfLines={1}
          >
            {format(card?.created_at, 'ccc, LLL d, yyyy h:mm a')}
          </Text>
          <Text
            variant='label-reg-lg'
            noOfLines={1}
          >
            {formatTimeDistance(card?.updated_at, 'short')}
          </Text>
        </HStack>
      </Stack>
      <Spacer />
      <Menu>
        <MenuButton
          as={IconButton}
          colorScheme='surface'
          variant='reskinGhost'
          px={3}
          size='sm'
          icon={<HorizontalDotMenuIcon />}
          hidden={hideMenu}
        />
        <MenuList>
          <MenuItem
            icon={<SFTrashIcon />}
            onClick={() => onRemove(card?.id)}
          >
            Remove
          </MenuItem>
        </MenuList>
      </Menu>
    </HStack>
  );
};

export default ExplorerSourceCard;
